<script lang="ts">
    
    import { userTypes } from "../../environment";

    export let value: number;

</script>

<select class="form-select" bind:value>
    {#each userTypes as userType}
        <option value={userType.id}>{userType.name}</option>
    {/each}
</select>
